<template>
    <div>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="AirLeadSuccess">
            <span>{{translate('airLeadGoodLack')}}</span>
        </div>
    </div>
</template>

<script>
import geoLocationMixin from "@/mixins/geoLocationMixin";
import errorMixin from '@/mixins/errorMixin';
import {mapActions, mapState} from 'vuex';
import customModalDialog from '@/components/widgets/customModalDialog';

export default {
    mixins: [mixin, errorMixin],
    components: {
        customModalDialog,
    },
    data() {
        return {
            customModalSettings: {},
        }
    },
    computed: {
        ...mapState({
            accessToken: state => state.auth.accessToken,
        })
    },
    async mounted() {

    },
    methods: {
        ...mapActions({
        }),

    }

}
</script>

<style>

</style>
<style scoped>
.AirLeadSuccess {
    position: absolute;
    display: flex;
    align-items: center;
    align-content: center;
    font-size: 16px;
    height: 100%;
    width: 100%;
}
.AirLeadSuccess span {
    width: 100%;
    padding: 24px;
    text-align: center;
}
</style>